import React from 'react';

const OrderDetails = () => {
    return (
        <div>
            order details page
        </div>
    );
};

export default OrderDetails;